import { MNSproCloudApi } from '..';
import { Severity, TaskStateResponse } from '../api/v2';

/**
 * Returns true if the given task is finished (either in error or success).
 */
export const isTaskDone = (
  taskStateResponse: Pick<TaskStateResponse, 'severity' | 'percentDone'>,
) =>
  taskStateResponse.severity === Severity.succeeded ||
  taskStateResponse.percentDone === 100;

export const isTaskFailed = (
  taskStateResponse: Pick<TaskStateResponse, 'severity'>,
) => taskStateResponse.severity === Severity.failed;

export class TasksService {
  private static getApi(authToken: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.TaskStatesApiFactory(config);

    return api;
  }

  /**
   * Returns true, if the given job identified by id is finished.
   */
  static async isJobDone(
    authToken: string,
    organizationId: string,
    jobId: string,
  ): Promise<boolean> {
    const taskStateResponse = await TasksService.getJobState(
      authToken,
      organizationId,
      jobId,
    );

    return isTaskDone(taskStateResponse);
  }

  static async getJobState(
    authToken: string,
    organizationId: string,
    jobId: string,
  ): Promise<TaskStateResponse> {
    const api = TasksService.getApi(authToken);
    const response = await api.get(jobId, organizationId);

    return response.data;
  }
}
